// Auth headers are now injected by the axios request interceptor
// (msalAxiosInterceptor.js) on every outbound request, so callers no
// longer need to pass a token or build an Authorization header here.
// These helpers stay for call-site uniformity and to keep the CSV Accept
// header in one place.
export const getHeaders = () => ({});

export const getHeadersForCsv = () => ({
  headers: { Accept: "text/csv;charset=utf-8" },
});
